"use client";

import { Toaster } from "react-hot-toast";

interface SessionWrapperProps {
  readonly children: React.ReactNode;
}

export default function SessionWrapper({ children }: SessionWrapperProps) {
  return (
    <>
      {children}
      <Toaster />
    </>
  );
}
